import { Toaster as Sonner, type ToasterProps, toast } from 'sonner';
import { useTheme } from '../../providers/ThemeProvider';

const toasterStyle = {
  '--normal-bg': 'hsl(var(--popover))',
  '--normal-text': 'hsl(var(--popover-foreground))',
  '--normal-border': 'hsl(var(--border))',
};

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      // @ts-expect-error - CSS custom properties for sonner theming
      style={toasterStyle}
      toastOptions={{
        classNames: {
          description: 'text-muted-foreground!',
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
